export const legalDocuments = {
  "privacy-policy": {
    title: "Privacy Policy",
    description:
      "Learn how we collect, use, and protect your personal information.",
    fileName: "privacy-policy.md",
    lastUpdated: "April 14, 2026",
    category: "privacy" as const,
  },
  "terms-of-service": {
    title: "Terms of Service",
    description:
      "Terms and conditions for using TERAC's platform and services.",
    fileName: "terms-of-service.md",
    lastUpdated: "June 15, 2026",
    category: "terms" as const,
  },
  "cookie-policy": {
    title: "Cookie Policy",
    description:
      "Information about how we use cookies and similar technologies.",
    fileName: "cookie-policy.md",
    lastUpdated: "June 22, 2025",
    category: "compliance" as const,
  },
  "support-terms": {
    title: "Support Terms",
    description: "Terms and conditions for our customer support services.",
    fileName: "support-terms.md",
    lastUpdated: "January 3, 2025",
    category: "terms" as const,
  },
  "job-applicant-privacy-notice": {
    title: "Job Applicant Privacy Notice",
    description: "Privacy information for job applicants and candidates.",
    fileName: "job-applicant-privacy-notice.md",
    lastUpdated: "July 1, 2025",
    category: "privacy" as const,
  },
  "responsible-disclosure": {
    title: "Responsible Disclosure",
    description:
      "Guidelines for reporting security vulnerabilities and issues.",
    fileName: "responsible-disclosure.md",
    lastUpdated: "January 17, 2025",
    category: "security" as const,
  },
  "data-deletion": {
    title: "Data Deletion Request",
    description: "How to request deletion of your personal data from TERAC.",
    fileName: "data-deletion.md",
    lastUpdated: "January 17, 2025",
    category: "compliance" as const,
  },
  "opportunity-policy": {
    title: "Opportunity Policy",
    description:
      "Guidelines for what types of opportunities are allowed and prohibited on the Terac platform.",
    fileName: "opportunity-policy.md",
    lastUpdated: "February 19, 2026",
    category: "terms" as const,
  },
  security: {
    title: "Security Policy",
    description:
      "How we protect your data, our infrastructure, certifications, and vulnerability disclosure policy.",
    fileName: "security.md",
    lastUpdated: "December 15, 2025",
    category: "security" as const,
  },
  gdpr: {
    title: "GDPR Privacy Notice",
    description:
      "Additional privacy disclosures for individuals in the EEA, UK, and Switzerland under the General Data Protection Regulation.",
    fileName: "gdpr.md",
    lastUpdated: "February 14, 2026",
    category: "privacy" as const,
  },
  mnpi: {
    title: "MNPI Acknowledgment",
    description:
      "Material Non-Public Information policy for research experts and researchers using the Terac platform.",
    fileName: "mnpi.md",
    lastUpdated: "February 14, 2026",
    category: "compliance" as const,
  },
  "accessibility-statement": {
    title: "Accessibility Statement",
    description:
      "Our commitment to making Terac's websites and products accessible to everyone, including people with disabilities.",
    fileName: "accessibility-statement.md",
    lastUpdated: "May 8, 2026",
    category: "compliance" as const,
  },
} as const;

export type LegalDocumentSlug = keyof typeof legalDocuments;
